import { ClickType } from './ClickType';
import { AddEventLog } from './EventLog';

export const EventSections = {
  Dashboard: 'dashboard',
  Book: 'book-sidepanel',
  TariffCodeCategory: 'tariff-code-category',
  QuickLinks: 'quick-links',
  NavigationSidebar: 'navigation-sidebar',
  QuickActions: 'quick-actions',
  MyAccount: 'my-account',
  QuickSelect: 'quick-select',
  Walkthrough: 'walkthrough',
  Onboarding: 'onboarding',
  ActionBar: 'actionbar',
  SmartSendSetup: 'smartsend-setup',
  BulkActionSideBar: 'bulk-action-sidebar',
  SmartSend: 'smartsend',
  InlineRules: 'rules',
  BookedItems: 'booked-items',
  Statements: 'statements',
  AccountConcerns: 'account-concerns',
  MarketplaceAccounts: 'marketplace-accounts',
  CsvMapping: 'csv-mapping',
  PackageContents: 'package-contents',
  PriceMatrix: 'price-matrix',
  Quotes: 'quotes',
  Tags: 'tags',
  CsvUpload: 'csv-upload',
  RestoreItem: 'restore-item',
  CreateItem: 'create-item',
  SmartSendItem: 'smartsend-item',
  SmartSendItemFooter: 'smartsend-item-footer',
  SmartSendGroup: 'smartsend-group',
  Warehouse: 'warehouse',
  PickingList: 'picking-list',
  PickAndPack: 'pick-and-pack'
};

export const EventLog: string[] = [];

const sectionSeperator = '>';
const sectionSanitiser = '-';

const showPreFix = (section: string) => {
  return section !== EventSections.TariffCodeCategory;
};

export const EventLogger = (sections: string[], eventType: ClickType, payload?: any) => {
  try {
    const secs = [...sections];

    if (showPreFix(secs[0])) {
      secs.unshift('v1');
    }

    // let segment = (
    //   UserCache.segmentationHistory?.length > 0
    //     ? UserCache.segmentationHistory
    //     : [{ SegmentName: 'Unknown', SegmentValue: 'Unknown' }]
    // )[0]?.SegmentValue;

    const segment = 'All';

    const jsn = {
      feature: `smartsend:${secs
        .filter((x) => !!x)
        .map((x) => x[0] + x.substring(1).replace(/([A-Z])/g, `${sectionSanitiser}$1`))
        .join(sectionSeperator)
        .replaceAll(':', sectionSanitiser)
        .replaceAll(`${sectionSanitiser}${sectionSanitiser}`, sectionSanitiser)
        .trim()}`.toLowerCase(),
      action: eventType,
      segment: segment
    };
    if (payload) {
      jsn['payload'] = payload;
    }
    console.log(jsn);
    AddEventLog(jsn.feature, jsn.action);
    if (navigator && navigator.sendBeacon) {
      navigator.sendBeacon('/push', JSON.stringify(jsn));
    }
  } catch (e) {
    console.error(e);
  }
};

export default EventLogger;
